import React from 'react';
import idcardcss from '../pages/css/idcard.module.css';
import { useState } from 'react';
import { useEffect } from 'react';
import { createdoctype, changedoctype } from '../tools/filehandler';
import { setErrorMessage } from "../tools/errorhandling";
import { CgCloseR } from "react-icons/cg";
import Button from 'react-bootstrap/Button';



const DeleteReason = ({ rights, t, id, cleaningassignment, events }) => {
    useEffect(() => {

    }, [id]);

    const saveDeleteReason = (e) => {

        events.handleCancel()
    }

    // 
    return (
        <div id="deletReason" className='focusOfTheDay'>
            {/* <div className='formcaption' onMouseDown={(e) => events.startdrag("deletReason", true, e)} onMouseUp={(e) => events.startdrag(null, false, e)}>
                {t('DeleteTask')}
                <CgCloseR className='closer' onClick={events.handleCancel} />
                </div> */}

            <div className='formcaption'>
                <div onMouseDown={(e) => events.startdrag("deletReason", true, e)} onMouseUp={(e) => events.startdrag(null, false, e)}>
                    {t('DeleteTask')}
                </div>
                <div onClick={events.handleCancel} >
                    <CgCloseR className='closer' />
                </div>
            </div>


            <div className="DeleteAssignmentForm">
                <label className='labelhotel'>
                    {t('DeleteTaskExplain')}
                </label>
                <div className='deleteassignmentFormGrid'>
                    <label className='labelhotel'>
                        {t('WhyDelete')}
                    </label>
                    <textarea id="ReasonForDelete" className="doublegrid" type='text' name="deleteReason" value={cleaningassignment.deleteReason} onChange={events.handleOnchange}>
                    </textarea>
                    &nbsp;
                    <div className='deleteassignmentFormGrid messageBoxes'>
                        <Button type="button" id="CloseMessageButton" className="OkCancel messageBoxAlignRight" onClick={events.HandleDelete}>{t("OK")}</Button>
                        <Button type="button" id="CancelMessageButton" className="OkCancel messageBoxAlignleft" onClick={events.handleCancel}>{t("Cancel")}</Button>
                    </div>
                </div>

            </div>

        </div>
    );
};


export default DeleteReason;
